import React from "react";
import { Icon, IconBaseProps } from "./Icon";

const LayoutThreeColumnsIcon: React.FC<IconBaseProps> = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g className="nc-icon-wrapper">
      <path d="M3 23.247a2.252 2.252 0 0 1-2.25-2.25v-18A2.252 2.252 0 0 1 3 .747h18a2.252 2.252 0 0 1 2.25 2.25v18a2.252 2.252 0 0 1-2.25 2.25H3zm18-1.5a.75.75 0 0 0 .75-.75v-18a.75.75 0 0 0-.75-.75h-3.75v19.5H21zm-5.25 0v-19.5h-7.5v19.5h7.5zM3 2.247a.75.75 0 0 0-.75.75v18c0 .414.336.75.75.75h3.75v-19.5H3z" />
    </g>
  </Icon>
);
export default LayoutThreeColumnsIcon;
